var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('BioTestingButtons',{attrs:{"title":"<i class=\"fas fa-home\"></i> Admin Quiz Actions"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }